// 공개 값 설정 오류 — 「로그인 안 함」(401)과 섞지 않고 화면·콘솔에 드러내려고 타입으로 가른다.
export class PublicEnvError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "PublicEnvError";
  }
}

// 브라우저 번들에 박히는 공개 값 — 비었거나 op:// 주소 그대로면(op run 없이 띄움) 쓰는 순간 멈춘다.
const read = (name: string, value: string | undefined): string => {
  if (!value) throw new PublicEnvError(`환경변수 ${name} 가 비어 있습니다 — op run 으로 띄우세요(.env.op 참고)`);
  if (value.startsWith("op://")) throw new PublicEnvError(`${name} 가 op:// 주소 그대로입니다 — op run 으로 띄우세요`);
  return value;
};

export interface PublicEnv {
  supabaseUrl: string;
  supabaseKey: string;
}

export const publicEnv = (env: ImportMetaEnv = import.meta.env): PublicEnv => ({
  supabaseUrl: read("NEXT_PUBLIC_SUPABASE_URL", env.NEXT_PUBLIC_SUPABASE_URL),
  supabaseKey: read("NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY", env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY),
});
